import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossYieldLinkedMarketFetch } from './actions';

export const sagasReportGrossYieldLinkedMarket = [
  takeLatest(actionReportGrossYieldLinkedMarketFetch.rejected, workerErrorNotifyThunk),
];
